module.exports = __webpack_public_path__ + "img/vip.e42e18f8.png";